export enum TimeRegistrationRoundingDirection {
  RoundUp = 'RoundUp',
  RoundDown = 'RoundDown',
}
